import { getItemWebStorage } from "../../../../../features/webStorageSaver";
import { showToastMessage } from "../../../../../stateManagement/reducers";
import { store } from "../../../../../stateManagement/store";

export const copyMapLink = (urlParams: any): void => {
    const currentConfig = getItemWebStorage('currentConfig')
    const mapPosition = getItemWebStorage('mapPosition') ?? {}
    const { longitude, latitude, zoom } = mapPosition
    const workspace = currentConfig.workspace
    let link = ''
    const currentWindow = window.location.origin;
    if (urlParams.objectType) {
        link = `${currentWindow}${process.env.PUBLIC_URL}/app/map/${urlParams.objectType}/?zoom=${zoom}&db=${workspace}&lat=${latitude.toFixed}&lon=${longitude}`;
    } else {
        link = `${currentWindow}${process.env.PUBLIC_URL}/app/map/${'AllRoadObjects'}/?zoom=${zoom}&db=${workspace}&lat=${latitude}&lon=${longitude}`;
    }
    navigator.clipboard.writeText(link)
        .then(() => {
            store.dispatch(showToastMessage({ messageText: 'Ссылка на карту скопирована в буфер обмена!', messageType: "info", windowType: "map" }))
        })
        .catch(error => {
            console.error('Ошибка копирования ссылки:', error);
        });
}